module.exports = __webpack_public_path__ + "staticVue/img/logo-dv-homepage.776d5266.png";